import odata from '@/core/api/mixin/odata'
import rest from '@/core/api/mixin/rest'

export default {
  ...odata('click-by-dynamic-configs'),
  ...rest('click-by-dynamic-configs'),
}
